export default __webpack_public_path__ + "static/media/volic2.ca1c76d9.jpg";